import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
class SellPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   thirdcolor,
   primary_logo,
   user,
   footer_logo,
   index_sell_contract,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   sell_invoice_obj.introduction !== undefined &&
   sell_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.introduction)
    : "";
  let numberWordsSorani2 =
   sell_invoice_obj.lastPrice !== undefined &&
   sell_invoice_obj.lastPrice !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.lastPrice)
    : 0;
  let numberWordsSorani3 =
   sell_invoice_obj.reject !== undefined && sell_invoice_obj.reject !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.reject)
    : 0;
  let numberWordsSorani4 =
   sell_invoice_obj.pay !== undefined && sell_invoice_obj.pay !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.pay)
    : 0;
  let numberWordsSorani5 =
   sell_invoice_obj.fee !== undefined && sell_invoice_obj.fee !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.fee)
    : 0;
  return (
   <>
    {/* New One */}
    <div className={`${lang === "en" ? "" : "container-fluid fkr "}`}>
     <div class="row" style={{ marginTop: 260 }}>
      <div class="col-4">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
        <Time
         value={sell_invoice_obj.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "24px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 d-flex justify-content-center">
       <p
        style={{
         fontSize: "26px",
         color: "#000",
         fontWeight: "bolder",
        }}
        class={`d-flex justify-content-center text-uppercase ${
         lang !== "en" ? "fk" : "fkp"
        } `}
       >
        ({change_Lang("sale and purchase contract")})
       </p>
      </div>
      <div class="col-4 text-right">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        {change_Lang("contract number")} #&nbsp;
        {index_sell_contract}&nbsp;
       </p>
      </div>
     </div>
     <div class="row">
      <div class="col-12">
       <div class="form-group row form-inline">
        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 col-form-label fkk"
        >
         {change_Lang("First Party (Seller)")}:
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "20px",
           color: "#000",
          }}
         >
          {sell_invoice_obj.firstname}
         </label>
        </div>

        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 col-form-label fkk"
        >
         {change_Lang("Second Party (Buyer)_")}:
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "20px",
           color: "#000",
          }}
         >
          {sell_invoice_obj.secondname}
         </label>
        </div>
        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 col-form-label fkk"
        >
         {" "}
         {change_Lang("first_rule_place")}:
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "23px",
           color: "#000",
          }}
         >
          {sell_invoice_obj.available_id &&
           sell_invoice_obj.available_id.Place_ku}
         </label>
        </div>

        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 fkk col-form-label"
        >
         {change_Lang("Type of property")}:
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "23px",
           color: "#000",
          }}
         >
          {change_Lang(
           sell_invoice_obj.available_id &&
            sell_invoice_obj.available_id.Property
          )}
         </label>
        </div>

        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 fkk col-form-label"
        >
         {sell_invoice_obj.available_id &&
         sell_invoice_obj.available_id.Property !== "Apartment"
          ? change_Lang("Number of property")
          : change_Lang("NumberOfShuqa")}
         :
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "23px",
           color: "#000",
          }}
         >
          {sell_invoice_obj.available_id &&
           sell_invoice_obj.available_id.NOoFProperty}
         </label>
        </div>

        <label
         style={{
          fontSize: "26px",
          color: "#000",
          fontWeight: "bold",
         }}
         class="col-sm-3 fkk col-form-label"
        >
         {" "}
         {change_Lang("Area")}:
        </label>
        <div class="col-sm-3">
         <label
          class="d-flex justify-content-start"
          style={{
           fontWeight: "bold",
           fontSize: "23px",
           color: "#000",
          }}
         >
          {sell_invoice_obj.available_id && sell_invoice_obj.available_id.Area}
          &nbsp;م<sup>2</sup>
         </label>
        </div>
       </div>
       <p
        style={{
         fontSize: "24px",
         color: "#2d5e69",
         fontWeight: "bolder",
         borderRadius: "50px 0px 0px 0px",
        }}
        id="liniar"
        class="my-3 d-flex justify-content-center fkr"
       >
        {change_Lang("agreement")}
       </p>
      </div>
     </div>
     <div className="row ">
      <div className="col-12">
       <table className="table">
        <tbody>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           1-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           من ({sell_invoice_obj.firstname}) خاوەن موڵك ڕەزامەندم بە فرۆشتنی ئەم
           موڵكەی لە سەرەوە ئاماژەی پێكراوە بە بڕی &nbsp;
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
            required
            className="text-center"
            prefix={"$"}
           />
           &nbsp;({numberWordsSorani2}
           &nbsp;دۆلاری &nbsp;ئەمریکی).
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           2-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           من ({sell_invoice_obj.secondname}) ڕەزامەندم بە کڕینی ئەم موڵکەی لە
           سەرەوە ئاماژەی پێکراوە بەبڕی &nbsp;
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
            required
            className="text-center"
            prefix={"$"}
           />
           &nbsp;&nbsp; ({numberWordsSorani2}
           &nbsp;دۆلاری &nbsp;ئەمریکی).
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "65px",
           }}
          >
           3-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           لایەنی دووەم بڕی &nbsp;
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj ? sell_invoice_obj.introduction : 0}
            required
            className="text-center"
            prefix={"$"}
           />
           &nbsp;({numberWordsSorani1}
           &nbsp;دۆلاری&nbsp;ئەمریکی)&nbsp; رادەستی لایەنی یەکەم کرد وەکو پێشەکی
           ، وە بڕی پارەی ماوە کە بڕی &nbsp;(
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj.pay}
            className="text-center"
            prefix={"$"}
           />
           &nbsp;
           {numberWordsSorani4}
           {lang === "en" ? "($)" : lang === "krd" ? "(دۆلار)" : "(دولار)"}
           )&nbsp;پێویستە رادەستی بکات لەبەرواری &nbsp;(
           <Time value={sell_invoice_obj.pay_day} format="YYYY-MM-DD" />
           )&nbsp;بەشێوەی (کاش) .
          </td>
         </tr>

         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           4-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           لەسەر لایەنی یەكەم پێویستە ئەم موڵكە ڕادەستی لایەنی دووەم بكات دوای
           وەرگرتنی تەواوی شایستە داراییەکانی لە رێكەوتی &nbsp;
           <Time
            value={sell_invoice_obj.duedate}
            format="YYYY-MM-DD"
            // style={{ color: "#000" }}
           />
           .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "70px",
           }}
          >
           5-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "3px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "22px",
            borderTop: "none",
           }}
          >
           ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاریکراودا ئەم موڵکەی ڕادەستی
           لایەنی دووەم نەکرد ئەوە دەبێت پابەند بێت بە پێدانی بڕی&nbsp;
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj.reject}
            className="text-center"
            prefix={"$"}
           />
           &nbsp;({numberWordsSorani3}
           &nbsp;دۆلاری &nbsp;ئەمریکی)&nbsp;وەکوو پێبژاردن (غرامە) بۆ هەر رۆژێک
           .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           6-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           لایەنی یەکەم لەئەستۆیەتی تا بەرواری رادەست کردنی موڵکەکە بە پێدانی
           هەر قەرزێک ئەگەر هەبێت لە خزمەتگوزاری ئاو کارەبا سەبارەت بە موڵکی
           ئاماژە پێکراو .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
            listStyleType: "circle",
           }}
          >
           7-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           ئەگەر هاتوو هەر لایەنێك بە هەر هۆیەك پاشگەز بێتەوە لەم گرێبەستە دەبێت
           بە لایەنەكەی تر قەرەبوو بکاتەوە بە &nbsp;&nbsp;
           <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={sell_invoice_obj.fee}
            className="text-center"
            prefix={"$"}
           />
           &nbsp; ({numberWordsSorani5}
           &nbsp;دۆلاری &nbsp;ئەمریکی) .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "60px",
           }}
          >
           8-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "4px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "24px",
            borderTop: "none",
           }}
          >
           تێچوو و ڕسوماتی فرۆشتن و گواستنەوە و جیاكردنەوە و یەكخستن و
           ڕاستكردنەوە و باجی خانووبەرە لەسەر لایەنی یەكەمە بیدات بەپێی یاسا
           ئەگەر تاپۆ بوو. بەڵام ئەگەر تاپۆ نەبوو لایەنی یەكەم پابەندە بە پێدانی
           بڕی تێچوی گواستنەوەی خاوەنداریەتی.
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
     <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />{" "}
     <br /> <br /> <br /> <br /> <br /> <br />
     <div className="row">
      <div className="col-12">
       <table className="table">
        <tbody>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           9-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           تێچووی ڕسوماتی كەشف و تۆماری عەقاری دەكەوێتە سەر لایەنی دووەم بە
           گوێرەی یاسا ئەگەر موڵكەكە تاپۆ بوو. وە ئەگەر تاپۆ نەبوو ئەوە لایەنی
           دووەم بە پێدانی بڕی پارەی بەناوكردن.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "60px",
           }}
          >
           10-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر هاتوو مولکی فرۆشراو تاپۆی هەبوو
           پێویستە لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە پارێزەر: (
           {sell_invoice_obj.lawman}) بەمەبەستی گواستنەوەی خاوەنداریەتی و
           تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "35px",
           }}
          >
           11-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           لایەنی یەکەم و لایەنی دووەم پابەند دەبن بە پێدانی رێژەی دیاری کراو
           (عمولە) بە پێ رێککەوتن لە نرخی ئەم موڵکە کەرێکەوتون لەسەری بۆ مافی{" "}
           {name_krd}.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            paddingBottom: "70px",
           }}
          >
           12-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە بە پێویستە
           لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ کێشەکە چارەسەر
           بکەن. بەلام ئەگەر چارەسەر نەکرا ئەوا لەرێگەی دادگاکانی هەولێر چارەسەر
           دەکرێ.
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            // paddingBottom: "35px",
           }}
          >
           13-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           لایەنی یەکەم وە لایەنی دووەم دوای واژوو کردنی گرێبەست مافی داواکردنی
           عمولەی پێدراویان نی یە .
          </td>
         </tr>
         <tr
          style={{
           fontSize: `${
            lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
           }`,
          }}
         >
          <th
           className={`${lang !== "en" ? "fkp" : "fkp"}`}
           scope="row"
           style={{
            color: `${thirdcolor}`,
            borderTop: "none",
            // paddingBottom: "35px",
           }}
          >
           14-
          </th>
          <td
           style={{
            lineHeight: "1.2",
            wordSpacing: "2px",
            color: "#000",
            fontWeight: "",
            textAlign: "justify",
            fontSize: "23px",
            borderTop: "none",
           }}
          >
           {name_krd} بەرپرس نییە لە بوونی هەر کێشەیەک کە لەنێوان فرۆشیار و
           کریار دا رووبدات.
          </td>
         </tr>
        </tbody>
       </table>
      </div>
     </div>
     <div className="form-inline">
      <label
       style={{
        fontSize: "18px",
        color: "#000",
        textAlign: "justify",
        fontWeight: "bold",
       }}
       className="form-label d-flex justify-content-start fkr"
      >
       {change_Lang("note")}&nbsp;: {sell_invoice_obj.note}
      </label>
     </div>
     <br />
     <br />
     <br />
     <div
      className="row mt-3"
      style={{
       width: "100%",
      }}
     >
      <div className="col-12">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "21px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Contract Organizer")}
        </label>
       </div>
      </div>
     </div>
     <div
      className="row"
      style={{
       width: "100%",
      }}
     >
      <div className="col-12 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
        }}
        className="form-label"
       >
        {`${sell_invoice_obj.agentId && sell_invoice_obj.agentId.fname} ${
         sell_invoice_obj.agentId && sell_invoice_obj.agentId.lname
        }`}
       </label>
      </div>
     </div>
     <br />
     <br />
     <br />
     <div
      className="row"
      style={{
       width: "100%",
      }}
     >
      <div className="form-group d-flex justify-content-center col-3">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
         fontWeight: "bold",
        }}
        className="form-label"
       >
        لایەنی یەکەم (فرۆشیار)
       </label>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Witness")}
        </label>
       </div>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         {change_Lang("Witness")}
        </label>
       </div>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
          fontWeight: "bold",
         }}
         className="form-label"
        >
         لایەنی دووەم (کڕیار)
        </label>
       </div>
      </div>
     </div>
     <div
      className="row"
      style={{
       width: "100%",
      }}
     >
      <div className="col-3 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
        }}
        className="form-label"
       >
        {sell_invoice_obj.firstname}
       </label>
      </div>
      <div className="col-3 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
        }}
        className="form-label"
       >
        {sell_invoice_obj.witness1}
       </label>
      </div>
      <div className="col-3 form-group d-flex justify-content-center">
       <label
        style={{
         fontSize: "20px",
         color: "#000",
        }}
        className="form-label"
       >
        {sell_invoice_obj.witness2}
       </label>
      </div>
      <div className="col-3">
       <div className="form-group d-flex justify-content-center">
        <label
         style={{
          fontSize: "20px",
          color: "#000",
         }}
         className="form-label"
        >
         {sell_invoice_obj.secondname}
        </label>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintKurdish);
